<template>
    <div class="index">
        <!-- appbar -->
        <mu-appbar style="width: 100%;position:fixed;" color="primary">
            <mu-button icon slot="left" @click="jumpBack()" v-if="showBack">
                <mu-icon value="chevron_left" size="30" color="#fff" @click="jumpBack"></mu-icon>
            </mu-button>
            <div class="nav-title">
                {{$t('buffetselect.title')}}
            </div>
            <mu-menu slot="right" style="margin-right:10px;margin-top:16px;" class="notranslate" :open.sync="isMenuOpen">
                    <mu-button fab small color="success">
                        {{getLanage()}}
                    </mu-button>
                    <mu-list slot="content">
                        <mu-list-item button @click="selectLanage('DK')">
                            <mu-list-item-title>DK</mu-list-item-title>
                        </mu-list-item>
                        <mu-list-item button @click="selectLanage('EN')">
                            <mu-list-item-title>EN</mu-list-item-title>
                        </mu-list-item>
                        <mu-list-item button @click="selectLanage('PT')">
                            <mu-list-item-title>PT</mu-list-item-title>
                        </mu-list-item>
                        <mu-list-item button @click="selectLanage('中文')">
                            <mu-list-item-title>中文</mu-list-item-title>
                        </mu-list-item>
                    </mu-list>
                </mu-menu>
        </mu-appbar>

        <!-- content -->
        <mu-container class="select-content">
            <img v-if="seller.buffetBannerImage" :src="getImgUrl(seller.buffetBannerImage,400)" alt="banner" style="width: 100%;max-height: 260px;" />
      
            <mu-form ref="form" class="buffet-form" :model="packageQuantity">
                <mu-form-item v-if="configsData.NumberTip">
                    <mu-alert color="info" style="background-color:#ccc;">
                        <mu-icon left value="info"></mu-icon>  
                         <span v-html="formattedNumberTip"></span>
                    </mu-alert>
                </mu-form-item>

                <mu-form-item :label="getText(food)" v-for="food, index in buffetPackageList" :key="index">
                    <div class="badge-num" :class="{select:i==food.current}" @click="selectNum(i,val,food)" v-for="(val,i) in options" :key="i">{{val}}</div>
                    <mu-text-field v-if="food.isMore" v-model="food.quantity" @change="statistical" type="number" placeholder="more number"></mu-text-field>
                </mu-form-item>

                <mu-form-item>
                    <div class="total-price">Total: {{totalPrice}} {{seller.unit}}</div>
                </mu-form-item>

                <mu-form-item   v-if="configsData.ChkRequireConfirm==1">
                     <mu-checkbox v-model="chkRequireConfirm" :label="formattedLabel"     class="multiline-label">
                     </mu-checkbox>
                </mu-form-item>

                <mu-form-item style="margin:auto;text-align:center;">
                    <mu-button color="success" large full-width @click="next" :disabled="btnDisabled" style="background-color:#da5b3a;width:94%;text-transform: unset;">
                        {{$t('buffetselect.next')}}
                    </mu-button>
                </mu-form-item>
            </mu-form>

            <mu-dialog :title="$t('buffetselect.successfulOrderTip')" width="360" height="220" :open.sync="openSimple" >
                {{$t('buffetselect.successTip')}}
                <!--<mu-button slot="actions" flat color="primary" @click="jumpBuffetMain" style="color: #da5b3a;"> {{$t('buffetselect.startBuffet')}}</mu-button>-->
            </mu-dialog>
        </mu-container>

    </div>
</template>
<script>
    import preventBack from 'vue-prevent-browser-back';
    export default {
        name: 'BuffetSelect',
        mixins: [preventBack],//注入  阻止返回上一页
        data() {
            return {
                buffetPackageList: [],
                configsData:[],
                seller: {},
                tableOrderInfo: {},
                packageQuantity: {},
                orderBuffetList: [],
                totalPrice:0,
                openSimple: false,
                openNumber: false,
                btnDisabled: false,
                showBack: false,
                isMenuOpen: false,
                chkRequireConfirm:false,
                options: [
                    '0', '1', '2', '3', '4',
                    '5', '6', '7', '8',
                    'More'
                ],
                moreOptions: [
                    '0','1', '2', '3', '4',
                    '5', '6', '7', '8',
                    '9', '10', '11', '12',
                    '13', '14', '15', '16',
                    '17', '18', '19', '20',
                    '21', '22', '23',
                    'More'
                ],
            }
        },
        components: {
        },
        mounted() {
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.getRestaurantInfo();
            this.getConfigs();
        },
        computed: {
             formattedNumberTip() {
                return this.configsData.NumberTip
                .replace(/\/s\/t/g, '<br>')  
                .replace(/\\n/g, '<br>');
            },
              formattedLabel() {
                return this.configsData.RequireConfirmInfo
                .replace(/\/s\/t/g, '\n')  
                .replace(/\\n/g, '\n')
                .replace(';', '\n');  
            }
        },
        methods: {
          
            async getConfigs() {  
                await this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            response.data.forEach((item) => {
                                this.configsData[item.configKey]= item.configValue;
			                })
                        }
                    });
            },
            getRestaurantInfo() {
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeBasicInfo/GetRestaurant', param)
                    .then(response => {
                        if (response.code==200) {
                            this.seller = response.data;
                            this.getOrderBuffetList();
                            window.localStorage.setItem('seller', JSON.stringify(this.seller));
                            this.getLanage();
                        } else {
                            this.$alert(this.$t("common.connotAccessed"), this.$t("common.alert"));
                        }
                    });
            },
            getLanage() {
                if (localStorage.getItem('lang') != undefined && localStorage.getItem('lang') != null) {
                    this.$i18n.locale = localStorage.getItem('lang');
                    return localStorage.getItem('lang');
                }
                this.$i18n.locale = this.seller.language;
                return this.seller.language;
            },
            selectLanage(lng) {
                this.$i18n.locale = lng;
                localStorage.setItem('lang', lng);
                this.isMenuOpen=false;
            },
            getText(food) {
                var description = '';
                if (food.description != null) {
                    description=food.description;
                }
                return food.foodName + "(" + food.price +" "+ this.seller.unit+")" + "  " + description
            },
            getBuffetList() {
                let param = {
                    restaurantId: this.seller.restaurantId
                };
                this.$get('QRCodeOrder/GetBuffetPackageList', param)
                    .then(response => {
                        if (response.code==200) {
                            response.data.forEach((food) => {
                                if (food.actDiscount==0) {
                                    food.actDiscount = 1;
                                }
                                food.isMore = false;
                                food.current = 0;
                                for (var m = 0; m < this.orderBuffetList.length; m++) {
                                    if (this.orderBuffetList[m].foodId == food.foodId) {
                                        food.quantity = this.orderBuffetList[m].quantity;
                                        this.showBack = true;
                                        if (food.quantity > 8) {
                                            food.isMore = true;
                                            food.current = food.quantity;
                                        }
                                        else {
                                            food.current = food.quantity;
                                            food.isMore = false;
                                        }
                                        break;
                                    }
                                }
                                this.buffetPackageList.push(food);
                            })
                            this.statistical();
                        }
                    });
            },
            getOrderBuffetList() {
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName
                };
                this.$get('QRCodeOrder/GetOrderBuffetPackage', param)
                    .then(response => {
                        if (response.code==200) {
                            this.orderBuffetList = response.data;
                        }
                        this.getBuffetList();
                    });
            },
            timeOutCheck() {
                var time = window.localStorage.getItem('timeOut');
                let that = this;
                if (time != undefined && time != null && time != "") {
                    var dateTimeStamp = new Date(time.replace(/-/g, '/')).getTime();
                    var now = new Date().getTime();
                    var diffValue = now - dateTimeStamp;
                    var minute = 1000 * 60;
                    var minC = diffValue / minute;
                    if (parseInt(minC) >= 120) {
                        this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                            type: 'warning', okLabel: this.$t("common.ok"),
                        }).then(function (result, value) {
                            that.$router.push({
                                path: '/error'
                            })
                        });
                        return false;
                    }
                    return true;
                }
                this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                    type: 'warning', okLabel: this.$t("common.ok"),
                }).then(function (result, value) {
                    that.$router.push({
                        path: '/error'
                    })
                });
                return false;
            },
            next() {
                this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                if (!this.timeOutCheck()) {
                    return;
                }
                let foods = [];
                let curNum = 0;
                this.buffetPackageList.forEach((food) => {
                    if (food.quantity) {
                        foods.push(food);
                        curNum += parseInt(food.quantity);
                    }
                })
                if (foods.length == 0) {
                    this.$alert(this.$t("common.selectPackage"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.configsData.ChkRequireConfirm==1 && !this.chkRequireConfirm){
                     this.$alert(this.formattedLabel, this.$t("header.info"), { okLabel: this.$t("common.sure")}).then(() => {
                         this.chkRequireConfirm=true;
                    });
                    return;
                }

                this.btnDisabled = true;
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName
                };
                this.$get('QRCodeOrder/GetOrderBuffetPackage', param)
                    .then(response => {
                        if (response.code==200 && response.data.length>0) {
                            this.orderBuffetList = response.data;
                            var num1 = 0;
                            this.orderBuffetList.forEach((food) => {
                                num1 += parseInt(food.quantity);
                            })
                            this.tableOrderInfo.number = num1;
                            var num2 = 0;
                            foods.forEach((food) => {
                                num2 += parseInt(food.quantity);
                            })
                            if (num2 < num1) {
                                this.btnDisabled = false;
                                this.$alert(this.$t("common.increased"), this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                                return;
                            }
                            this.btnDisabled = true;
                            this.$confirm(this.$t("common.moreNeed", { beginNum: num1, nowNum:(num2 - num1)}), this.$t("common.submit"), {
                                type: 'info',
                                okLabel: this.$t("common.ok"),
                                cancelLabel: this.$t("common.cancel")
                            }).then(({ result }) => {
                                if (result) {
                                    this.tableOrderInfo.number = num2;
                                    window.localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                                    this.addOrderCart(foods);
                                }
                                else {
                                    this.tableOrderInfo.number = num1;
                                    window.localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                                    this.$router.push({ path: '/buffet' });
                                }
                            })
                        }
                        else {
                            this.tableOrderInfo.number = curNum;
                            window.localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                            this.addOrderCart(foods);
                        }
                    });
               
            },
            addOrderCart(foods) {
                this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                var tempFoods = [];
                foods.forEach((food) => {
                    var isHas = false;
                    for (var m = 0; m < this.orderBuffetList.length; m++) {
                        if (this.orderBuffetList[m].foodId == food.foodId) {
                            isHas = true;
                            food.quantity = food.quantity - this.orderBuffetList[m].quantity;
                            if (food.quantity > 0) {
                                tempFoods.push(food);
                            }
                            break;
                        }
                    }
                    if (!isHas) {
                        tempFoods.push(food);
                    }
                })
                if (tempFoods.length == 0) {
                    this.$router.push({ path: '/buffet' });
                    return;
                }

                var cartList = [];
                tempFoods.forEach((food) => {
                    cartList.push({
                        RestaurantId: this.tableOrderInfo.restaurantId,
                        TableName: this.tableOrderInfo.tableName,
                        FoodTypeName: food.foodTypeName,
                        FoodId: food.foodId,
                        FoodName: food.foodName,
                        FoodImage: food.foodImage,
                        Price: food.price,
                        Quantity: food.quantity,
                        FoodDiscount: food.actDiscount,
                        DecideName: food.decideName == undefined ? "" : food.decideName,
                        CreateUser: this.tableOrderInfo.name,
                        CreatePhone: this.tableOrderInfo.telephone,
                        IsSeft: 0,
                        AllowDiscounts: food.allowDiscounts,
                    })
                })
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName,
                    shopCartList: JSON.stringify(cartList)
                };
                this.$post('QRCodeOrder/AddtoCartList',param)
                    .then(response => {
                        if (response.code == 200) {
                            this.order();
                        } else {
                            this.$alert(this.$t("common.connotAccessed"), this.$t("common.alert"));
                        }
                    });
            },
            dataLen(d) {
                if (d < 10) {
                    return "0" + d;
                }
                return d;
            },
            order() {
                this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
                this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');

                var myDate = new Date();
                var orderDate = myDate.getFullYear() + "-" + this.dataLen(myDate.getMonth() + 1) + "-" + this.dataLen(myDate.getDate()) + " " + this.dataLen(myDate.getHours()) + ":" + this.dataLen(myDate.getMinutes()) + ":00";
                let param = {
                    OrderType: 1,
                    RestaurantId: this.seller.restaurantId,
                    TableName: this.tableOrderInfo.tableName,
                    OrderFrom: 5,
                    OrderDay: orderDate,
                    DeliveryType:1,
                    OrderProcess:1,
                    OrderAmount: 0,
                    OrderDiscount: 1,
                    ActualAmount: 0,
                    PostAmount: 0,
                    CouponAmount: 0,
                    State:1,
                    CustomerName: this.tableOrderInfo.name,
                    Telephone: this.tableOrderInfo.telephone,
                    Adult: this.tableOrderInfo.number,
                    Child: 0,
                    Specielle: this.tableOrderInfo.specielle,
                    PaymentType:0,
                    IsInvoice:0,
                    IsConformed:0,
                    OrderId: 0,
                    AccountId:0,
                    Rabatkode: '',
                    IsOrderBuffetPackage:1,
                    IsSendSms: this.tableOrderInfo.isSendSms,
                    RedisKey: this.orderRediskey + this.tableOrderInfo.restaurantId+"-"+ this.tableOrderInfo.tableName
                }
                this.$post('QRCodeOrder/OrderQRCodeCartList', param)
                    .then(response => {
                            if (response.code == 200) {
                                this.openSimple = true;
                                let timer0 = setTimeout(() => {
                                    this.openSimple = false;
                                    this.jumpBuffetMain();
                                }, 2000)
                            }
                            else {
                                this.$alert(this.$t(response.msg), this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.sure") });
                            }
                    });
            },
            selectNum(index, val, food) {
                food.current = index;
                if (val != 'More') {
                    food.isMore = false;
                    if (val == 0) {
                        food.quantity = "";
                    }
                    else {
                        food.quantity = val;
                    }
                }
                else {
                    if (this.options != this.moreOptions) {
                        this.options = this.moreOptions;
                    }
                    else {
                        food.isMore = true;
                    }
                }
                this.statistical();
            },
            statistical() {
                this.totalPrice = 0;
                this.buffetPackageList.forEach((food) => {
                    if (food.quantity > 0) {
                        this.totalPrice += food.quantity * food.price
                        }
                });
            },
            clear(food) {
                food.quantity = null;
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            refresh() {
                this.$toast.success('Refresh successfully!');
            },
            jumpBuffetMain() {
                this.$router.push({ path: '/buffet' });
            },
            jumpIndex() {
                this.$router.push({ path: '/' });
            },
            jumpBack() {
                this.$router.push({ path: '/buffet' });
            },
        },
        activated() {
            
        }
    }
</script>
<style>


.multiline-label .mu-checkbox-label {
  white-space: pre-line; 
  word-break: break-word;
  line-height: 1; 
  text-align: left;
    vertical-align: top;
    padding-left: 15px;
}

/* 确保 mu-checkbox 本身也能自适应 */
.adaptive-checkbox-item .mu-checkbox {
  align-items: flex-start !important; /* 顶部对齐 */
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .buffet-form {
        width: 95%;
        margin: 0 auto;
        margin-top: 20px;
    }
    .nav-title {
        text-align: center;
    }

    .mu-list {
        padding: 5px 0;
    }

    .mu-button {
        text-transform: unset;
    }

        .mu-button .mu-icon-left {
            margin-right: 3px;
        }

        .mu-button .mu-icon-right {
            margin-right: 5px;
        }

    .mu-raised-button .mu-button-wrapper {
        padding: 0;
    }

    .material-icons {
        font-size: 16px;
    }

    .select-content {
        padding-left: 0px;
        padding-right: 0px;
        top: 58px;
        position: absolute;
        width: 100%;
        bottom: 10px;
        overflow-y:auto;
    }

    .select-cart-wrapper {
            position: absolute;
            right: 0;
            bottom: 12px;
            z-index:10;
        }
    .badge-num {
        float: left;
        width: 60px;
        height: 32px;
        margin-right: 5px;
        margin-bottom: 5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 6px;
        line-height: 1.5;
        font-size: 14px;
        font-style: normal;
        background-color: #bdbdbd;
        color: #fff;
        border-radius: 3px;
        overflow: hidden;
    }

    .select {
        background-color: rgb(218, 91, 58);
    }

    .total-price {
        color: #ff0000;
        font-size: 18px;
        font-weight:600;
        text-align:right;
        width:100%;
       margin-right:20px;
    }

    
</style>



// WEBPACK FOOTER //
// src/components/BuffetSelect.vue